module.exports = __webpack_public_path__ + "media/images/bg/shapes/husk-bb60b75bc9d80112fc6ec8d66219fb68.svg";